

let countryParam = getUrlParameter('country');
if (countryParam.toLowerCase() == 'rus') countryParam = 'gbr';
//Empty array ready to loop through the regions
var regions = [];
var activeCountry = "";
var pageCount = 1;

var productDetails = {
    "EmailIntelligence":"Check the fraud risk score of an email based on transactional & behavioural history",
    "GbgTrust":"Check against a consortium of global data, scoring matches & detecting anomalies",
    "SyntheticIDScore":"Check the score of bureau data to prevent synthetic identity fraud",
    "MobileIntelligence":"Check mobile number ownership to help verify identities and prevent fraud",
    "UkBankChecks":"Check against a consortium of global data, scoring matches & detecting anomalies",
    "DeviceIntelligence":"Detect whether a device has a history of fraud",
    "DocumentTamperDetection":"Detect physical and digital tampering to reduce your risk of fraud", //Need to udpate description
};

//Call all of the loading functions

//var heroGlobe = $(".hero-globe")[0].offsetWidth;
//$(".hero-globe").css('min-height', heroGlobe);

$(document).ready(function () {
    //By default get the nav is something doesnt load
    getNav()
    countryChange()
    getDocTypes(countryParam,1,false)
    getDocTypesFilter(countryParam)
    getCountryData(countryParam)

    //console.log(productDetails)

    //check to see if forward and back
    window.addEventListener("popstate", (event) => {

        //console.log(`location: ${document.location}, state: ${JSON.stringify(event.state)}`,)

        //console.log("event state" + event.state.cc)

        if (event.state == null) {
            var previousCountry = getUrlParameter("country");

            //console.log("the prev country is " + previousCountry)
            getCountryData(previousCountry)

            $('#countryPicker').val(previousCountry);

            //need to update the dropdown now
        }
        else if (event.state != null) {
            if (event.state.cc != undefined) {

                getCountryData(event.state.cc)
                $('#countryPicker').val(event.state.cc);
            }
        }

        //console.log(event.state.cc)

    });

    window.addEventListener('resize', (event) => {
        const size =  document.getElementById('globeViz').parentNode.getBoundingClientRect().width;
        world.width(size+300)
        world.height(size + 300)

    });

    //Globe
    const
        globeWidth = document.getElementById('globeViz').parentNode.getBoundingClientRect().width;
    world = Globe()
        (document.getElementById('globeViz'))

        .width([globeWidth+300])
        .height([globeWidth+300])
        .backgroundColor('#271E2C')
        .globeImageUrl('/assets/img/map-BG700.png')
        //.pointOfView({ altitude: 4 }, 5000)
        .polygonCapColor(feat => 'rgba(255, 255, 255, 0.6)')
        .polygonSideColor(() => 'rgba(0, 100, 0, 0.05)')
    //.polygonLabel(({ properties: d }) => `
    //      <b>${d.ADMIN} (${d.ISO_A2})</b> <br />
    //      Population: <i>${Math.round(+d.POP_EST / 1e4) / 1e2}M</i>
    //    `);
    world.polygonsData(fetchGlobeData(countryParam))
    world.controls().enableZoom = false;
    

})

//getIdentifiers(countryParam);
//getSources(countryParam);
//getTypes(countryParam, pageCount);

$(".load-more-coverage").click(function () {
    pageCount++;
    //console.log("The page count is " + pageCount);
    //console.log("load more clicked");
    getDocTypes(countryParam, pageCount,true);
});



function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
};



function getNav() {
    //Write out the navigation
    //$.ajax('/api/coverage/getpagedata/?cc=all',
    $.ajax('/api/coverage/getsupportingdata/?cc=all&limit=1000&page=1',
        {

            success: function (data, status, xhr) {
                $.each(data, function (val, key) {
                    var countries = data[val].Countries;
                    console.log(countries);




                    //update navigation
                    for (let i = 0; i < countries.length; i++) {

                        if (countries[i]['CountryCode'].toLowerCase() == 'rus') continue;

                        var countryMatch = false;

                        if (countryParam.toLowerCase() == countries[i]['CountryCode'].toLowerCase()) {
                            countryMatch = true;
                        }

                        if (countryMatch) {
                            $('#countryPicker').append("<option selected value=" + countries[i]['CountryCode'].toLowerCase() + " > " + countries[i]["Country"] + "</option>");
                        } else {
                            $('#countryPicker').append("<option value=" + countries[i]['CountryCode'].toLowerCase() + " > " + countries[i]["Country"] + "</option>");
                        }


                        //If the country code matches the param request update the content
                        if (countryParam.toLowerCase() == countries[i]['CountryCode'].toLowerCase()) {
                            

                            //console.log(countries[i])

                            //dataSources
                            var dataSources = countries[i]["DataSources"].split(",");

                            var dataSourcesOutput = "";
                            $.each(dataSources, function (val) {
                                dataSourcesOutput += "<li class=\"" + dataSources[val] + "\">" + dataSources[val] + "</li>";
                                //console.log(dataSources[val]);
                            });

                            

                            $('#SourcesBody').html("<tr><td class=\"" + data[val].Datasources + "\"><ul class=\"list-unstyled\">" + dataSourcesOutput + "</ul></td><td class=\"" + countries[i]["UniqueSources"] + "\">" + countries[i]["UniqueSources"] + "</td><td class=\"" + countries[i]["CoverageOfAdultPopulation"] + "\">" + countries[i]["CoverageOfAdultPopulation"] + "</td><td class=\"" + countries[i]["AverageOneSourceMatch"] + "\">" + countries[i]["AverageOneSourceMatch"] + "</td><td class=\"" + countries[i]["AverageTwoSourceMatch"] + "\">" + countries[i]["AverageTwoSourceMatch"] + "</td></tr>");
                            //Fade in if results
                            $('#identity-sources').fadeIn();

                        }
                        
                    }



                    /*if (getUrlParameter("country))*/
                    



                    
                    
                    

                });

            },


        });


}

function countryChange() {
    var dataReady = false;

    $('#countryPicker').on('change', function () {

        countryParam=this.value

        $(".check").fadeOut()
        
        $("#searching").show()
        $("#resultsContainer").fadeOut()
        $("#results").html("")
        $("#supportedDocs").fadeOut()
        //console.log(this.value)
        getCountryData(this.value)

        //$('#TypeBody')[0].innerHTML='';
        //console.log($('#TypeBody')[0].innerHTML)
        //$('#TypeBody').innerHTML = '';
        $('#TypeBody')[0].innerHTML = '';
        $('#TypeAccordion')[0].innerHTML = '';
        getDocTypes(this.value, 1, true)
        getDocTypesFilter(this.value)
        const state = { cc: this.value };
        const url = "?country=" + this.value;

        history.pushState(state, "", url);
        fetchGlobeData(this.value)


        //Check if data is ready and slide back in
        //$("#coverageOverview").slideUp(500);
        //$("#coverageOverview").slideDown(1000);
    })
}


//Main data for the page
function getCountryData(countryCode) {
    //Write out the navigation
    //$.ajax('/api/coverage/getpagedata/?cc=all',
    $.ajax('/api/coverage/getsupportingdata/?cc='+countryCode+"&limit=1&page=1",
        {

            success: function (data, status, xhr) {
                $.each(data, function (val, key) {
                    var countries = data[val].Countries;
                   // console.log(countries);

                    var country = countries[0];

                    //console.log(country)

                    //dataSources
                    var dataSources = countries[0]["DataSources"].split(",");

                    var dataSourcesOutput = "";
                    $.each(dataSources, function (val) {

                        dataSourcesOutput += "<li class=\"" + dataSources[val] + "\">" + dataSources[val] + "</li>";
                        //console.log(dataSources[val]);
                    });

                    
                    //Update content
                    //Overview
                    $('#countryName').fadeOut(function () {
                        $('#countryName').html(country["Country"]);
                        $('#countryName').fadeIn();
                    });


                    $('.countryName').html(country["Country"]);

                    $('#numDataSources').fadeOut(function () {
                        $('#numDataSources').html(country["UniqueSources"]);
                        $('#numDataSources').fadeIn();
                    });

                    if (country["UniqueSources"] == '') {
                        document.querySelector('.identity-document-coverage .data-checks').style.display = 'none';
                    } else {
                        document.querySelector('.identity-document-coverage .data-checks').style.display = '';
                    }

                    $('#populationCoverage').fadeOut(function () {
                        if (country["CoverageOfAdultPopulation"] == '') {
                            $('#populationCoverage').html('');
                            $('#populationCoverageHeader').fadeOut();
                            $('#populationCoverageAsterisk').fadeOut();
                        } else {
                            $('#populationCoverage').html(country["CoverageOfAdultPopulation"] + "<sup>&#x2a;</sup>");
                            $('#populationCoverageHeader').fadeIn();
                            $('#populationCoverageAsterisk').fadeIn();
                        }
                        $('#populationCoverage').fadeIn();
                    });

                    if (country["UniqueSources"] != "" || country["CoverageOfAdultPopulation"] != "") {
                        $('#coverageStats').fadeIn();
                    }

                    $('#dataSourcesContainer').fadeOut(function (){
                        $('#dataSources').html(country["DataSources"]);
                        
                    });

                    if (country["DataSources"] != "") {
                        $('#dataSourcesContainer').fadeIn();
                    }

                    $('#dataSourceUpdatesContainer').fadeOut(function () {
                        $('#dataSources').html(country["DataSources"]);
                        
                    });


                    if (country["DataSources"] != "") {
                        $('#dataSourceUpdatesContainer').fadeIn();
                    }
                    


                    $('#SourcesBody').html("<tr><td class=\"" + data[val].Datasources + "\">" + dataSourcesOutput + "</td><td class=\"" + country["UniqueSources"] + "\">" + country["UniqueSources"] + "</td><td class=\"" + country["CoverageOfAdultPopulation"] + "\">" + country["CoverageOfAdultPopulation"] + "</td><td class=\"" + country["AverageOneSourceMatch"] + "\">" + country["AverageOneSourceMatch"] + "</td><td class=\"" + country["AverageTwoSourceMatch"] + "\">" + country["AverageTwoSourceMatch"] + "</td></tr>");
                    //Fade in if results
                    $('#identity-sources').fadeIn();

                    

                    var matchingMandatory = countries[0]["MatchingMadatoryFields"].split(",");
                    var matchingOptional = countries[0]["MatchingOptionalFields"].split(",");

                    var matchingMandatoryOutput = "";
                    var matchingOptionalOutput = "";
                    $.each(matchingMandatory, function (val) {

                        matchingMandatoryOutput += "<li><span class=\"true\"></span>" + matchingMandatory[val] +"</li>";
                        //console.log(dataSources[val]);
                    });

                    $.each(matchingOptional, function (val) {
                        if (matchingOptional[val] != "") {
                            matchingOptionalOutput += "<li><span class=\"true\"></span>" + matchingOptional[val] + "</li>";
                        }
                    });

                    $('#matchingContainer').fadeOut(function () {
                        if (countries[0]["MatchingMadatoryFields"] != "") {
                            $('#matchingListMandatory').html(matchingMandatoryOutput);
                            if (matchingOptionalOutput != "") {
                                $('#matchingListOptional').html(matchingOptionalOutput);
                                $('#matchingListOptionalContainer').fadeIn()
                            }
                            else {
                                $('#matchingListOptionalContainer').fadeOut()
                            }
                            $('#matchingContainer').fadeIn();
                        }

                    });
                    //
                    //
                    //
                    //
                    console.log(countries[0])
                    var affordability = countries[0]["Affordability"].split(",");

                    

                    var affordabilityOutput = "";

                    $.each(affordability, function (val) {

                        affordabilityOutput += "<li><span class=\"true\"></span>" + affordability[val] + "</li>";
                        //console.log(dataSources[val]);
                    });


                    $('#affordabilityContainer').fadeOut(function () {
                        if (countries[0]["Affordability"] != "") {
                            $('#affordabilityList').html(affordabilityOutput);
                           
                            $('#affordabilityContainer').fadeIn();
                        }

                    });


                    //$('#matchingList').html(matchingMandatoryOutput);
                    ////Fade in if results
                    //if (countries[0]["MatchingMadatoryFields"] != "") {
                    //    $('#matchingContainer').fadeIn();
                    //}

                    //console.log(country["GbgScore"]);

                    if (country["GbgScore"] == "YES" || country["GbgScore"] == "TRUE") {
                        $('#gbgScore').html("<li><span class=\"true\"></span>GBG Identity Score available in this region</li>")
                    }
                    else if (country["GbgScore"] == "NO" || country["GbgScore"] == "FALSE" || country["GbgScore"]=="") {
                        $('#gbgScore').html("<li><span class=\"false\"></span>GBG Identity Score coming soon in this region</li>")
                    }
                    $('#gbgScoreContainer').fadeIn();

                    var products = ""
                    var productsTable = ""

                    $.each(country["Products"][0], function (key, val) {
                        if (val == 'TRUE') {
                            /*console.log(val)*/
                            var splitUpper = key.match(/[A-Z][a-z]+/g);
                            //console.log(splitUpper)
                            var objIndex = splitUpper.findIndex((obj => obj == "Gbg"));
                            splitUpper[objIndex] = "GBG"
                            var objIndex = splitUpper.findIndex((obj => obj == "Id"));
                            splitUpper[objIndex] = "ID"
                            var objIndex = splitUpper.findIndex((obj => obj == "Uk"));
                            splitUpper[objIndex] = "UK"

                            products += "<li>" + splitUpper.join(' ') + "</li>";

                            if (key in productDetails) {
                                //console.log(splitUpper.join(' '))
                                //console.log(productDetails[key])
                                productsTable += "<tr><td>" + splitUpper.join(' ') + "</td><td>"+productDetails[key]+"</td></tr>";
                            } 
                        }
                    });


                    //Add default products
                    products += "<li>Document Tamper Detection</li>";
                    productsTable += "<tr><td>Document Tamper Detection</td><td>" + productDetails["DocumentTamperDetection"] + "</td></tr>";
                    

                    $('#fraudChecksContainer').fadeOut(function () {
                        //console.log(country["fraudChecks"]);
                        $('#fraudChecks').html(products);
                        $('#fraudChecksContainer').fadeIn();
                        $('#fraudChecks').fadeIn();
                    });

                    //console.log(productsTable)

                    $('#products').fadeOut(function () {
                        if (productsTable != "") {
                            $('#productsTable').html(productsTable);
                            $('#products').fadeIn();
                        }
                    })
                        
                    
                });

            },


        });


}

function getDocTypes(countryCode, page,destroy) {
    //Country specific types

    //$('#TypeBody')[0].innerHTML = '';

    //$.ajax('/api/coverage/getdoctypesfilter/?cc=' + countryCode + "&filter=IssueType",
    //$.ajax('/api/coverage/getdoctypes/?cc=' + countryCode + "&limit=10&page=" + page,
    $.ajax('/api/coverage/getdocissuetypes/?cc=' + countryCode + "&limit=10&page=" + page,
        {
            success: function (data, status, xhr) {


                //console.log(data)
                $.each(data[0].IssueTypes, function (key,types) {

                    //$('#TypeBody').append("<tr><td>" + data[0].Countries[val].Country + "</td><td>" + data[0].Countries[val].Idtype + "</td><td>" + data[0].Countries[val].Side + "</td><td>" + data[0].Countries[val].Years + "</td></tr>");
                    //$('#TypeBody').append("<tr><td>" + data[0].Countries[val].Idtype + "</td><td>" + data[0].Countries[val].Side + "</td><td>" + data[0].Countries[val].Years + "</td></tr>");
                    //$('#TypeBody').append("<tr><td>" + this["ClassName"] + "</td><td>" + this["Name"] + "</td><td>" + this["IssueType"] + "</td></tr>");
                    /*$('#TypeBody').append("<tr><td>" + this + "</td></tr>");*/
                    var documents = "";

                    var issueName = this["Name"]


                    $.each(this["Documents"], function (key, val) {
                        //documents += "<li>" + val["FriendlyName"] + "</li>";
                        documents += "<li class=\"pg-sm\">" + val["FriendlyName"] + "</li>";
                    });

                    //$('#TypeBody').append("<tr><td>" + this["Name"] + "<ul>" + documents +"</ul></td></tr>");
                    $('#TypeAccordion').append("<h5>" + this["Name"] + "</h3><ul class=\"list-unstyled\">" + documents +"</ul></div>");
                    
                    
                   
                });
                

                if (page >= data[0].Pagination[0].Pages) {
                    $(".load-more-coverage").hide();
                }
                else {
                    $(".load-more-coverage").show();
                }

                if (data[0].Pagination[0].TotalResults == 0) {
                    $('#biometric').fadeOut();
                    document.querySelector('.identity-document-coverage .bio-checks').style.display = 'none';
                } else {
                    $('#biometric').fadeIn();
                    document.querySelector('.identity-document-coverage .bio-checks').style.display = '';
                }
                $('#identity-coverage').fadeIn();

                if (destroy == true) {
                    $("#TypeAccordion").accordion("destroy");
                }
                $("#TypeAccordion").accordion({
                    heightStyle: "content", collapsible: true, active: false, speed: 'slow'
                });
            }
        });
}


function getDocTypesFilter(countryCode, filter) {
    //Country specific types
    $('#ClassNames ul')[0].innerHTML = '';

    //$.ajax('/api/coverage/getdoctypes/?cc=' + countryCode /+ "&limit=60&page=" + page*/,
    $.ajax('/api/coverage/getdoctypesfilter/?cc=' + countryCode + "&filter=ClassName",
        {
            success: function (data, status, xhr) {

                //var result = [];
                var result = "";

                //console.log(data)
                $.each(data, function (key, val) {
                    
                    //$('#TypeBody').append("<tr><td>" + data[0].Countries[val].Country + "</td><td>" + data[0].Countries[val].Idtype + "</td><td>" + data[0].Countries[val].Side + "</td><td>" + data[0].Countries[val].Years + "</td></tr>");
                    //$('#TypeBody').append("<tr><td>" + data[0].Countries[val].Idtype + "</td><td>" + data[0].Countries[val].Side + "</td><td>" + data[0].Countries[val].Years + "</td></tr>");
                    //$('#TypeBody').append("<tr><td>" + this["ClassName"] + "</td><td>" + this["Name"] + "</td><td>" + this["IssueType"] + "</td></tr>");
                   // $('#ClassNames ul').append('<li class="badge text-light bg-ink900 lb-sm rounded-3 me-0_5">'+this+'</li>');
                    
                    if (val != "Other" && val != "Unknown") {

                        result += "<li class=\"icon-" + this.replace(/ /g, '').toLowerCase() + "\">" + this + "</li>";
                    }
                   //result.push(this)
                });

                $('#supportedDocsContainer').fadeOut(function () {
                    $('#supportedDocs').html(result);
                    $('#supportedDocs').fadeIn();
                    if (result != "") {
                        $('#supportedDocsContainer').fadeIn();
                    }
                });

                


                //if (page >= data[0].Pagination[0].Pages) {
                //    $(".load-more-coverage").hide();
                //}
                //else {
                //    $(".load-more-coverage").show();
                //}

                $('#ClassNames').fadeIn();

                

            }
        });
}



function fetchGlobePos(cc) {
    //console.log(cc)

    const response = fetch('/Assets/datasets/countries_codes_and_coordinates.json').then(res => res.json()).then(countries => {
        var country = countries.features.filter(d => d.A3 == cc.toUpperCase());
        //console.log(country);
        var lat = country[0].Lat
        var lng = country[0].Lng
        var latLng = [{ "lat": lat, "lng": lng }]
        //console.log(latLng)
        

    });
    return response;
}


function fetchGlobeData(cc) {

    //world.polygonCapColor(feat => 'rgba(255, 255, 255, 0)')

     const result = fetch('/Assets/datasets/countries.json').then(res => res.json()).then(countries => {
        //world.polygonsData(countries.features.filter(d => d.properties.ISO_A2 !== 'AQ'));
        world.polygonsData(countries.features.filter(d => d.properties.ISO_A3 == cc.toUpperCase()));
        //return countries.features.filter(d => d.properties.ISO_A3 == cc.toUpperCase())
        var currentCountry = countries.features.filter(d => d.properties.ISO_A3 == cc.toUpperCase())
        
        

    const
        $globe = document.getElementById('globeViz')

        const globeWidth = $globe.parentNode.getBoundingClientRect().width;
        //world.width([globeWidth])
        //world.height([globeWidth])
        
        //console.log(countryParam.toUpperCase())

        //console.log(currentCountry);
        //console.log(currentCountry[0]["bbox"]);
        //console.log(currentCountry[0]["geometry"]["coordinates"][0][0][0]);


        //var dataLat = currentCountry[0]["bbox"][1]
        //var dataLng = currentCountry[0]["bbox"][0]

        //var dataLat = currentCountry[0]["geometry"]["coordinates"][0][0][0][1]
        //var dataLng = currentCountry[0]["geometry"]["coordinates"][0][0][0][0]

        //console.log("lat:" + dataLat + "lng:" + dataLng);
        //world.pointOfView({ lat: dataLat, lng: dataLng, altitude: 1.5 }, 5000);
        //world.pointOfView({ lat: -40.792549, lng: 145.397978, altitude: 1.5 }, 10000);


        //setTimeout(() => world
        //    .polygonsTransitionDuration(4000)
        //    .polygonAltitude(feat => Math.max(0.1, Math.sqrt(+feat.properties.POP_EST) * 7e-5))
        //    , 3000);
    });

    //Getting the coordinates from a different file
    result.then(r => {
        const response = fetch('/Assets/datasets/countries_codes_and_coordinates.json').then(res => res.json()).then(countries => {
            var country = countries.features.filter(d => d.A3 == cc.toUpperCase());
            //console.log(country);
            var dataLat = country[0]["Lat"]
            var dataLng = country[0]["Lng"]
            //var latLng = [{ "lat": dataLat, "lng": dataLng }]
            world.pointOfView({ lat: dataLat, lng: dataLng, altitude: 1.5 }, 5000);

        });
    })
}

//$('#search').keyup(function () {
//    $('#results').html('');
//    $('#state').val('');
//    var searchField = $('#search').val();
//    var expression = new RegExp(searchField, "i");
//    $.getJSON('/api/coverage/getdoctypes/?cc=' + countryParam+'&filter=', function (data) {
//        $.each(data, function (key, value) {
            
//            if (value.FriendlyName.search(expression) != -1 /*|| value.location.search(expression) != -1*/) {
//                $('#results').append('<li class="list-group-item link-class"> ' + value.FriendlyName + '</li>');
//            }
//        });
//    });
//});

//$('#results').on('click', 'li', function () {
//    var click_text = $(this).text().split('|');
//    $('#search').val($.trim(click_text[0]));
//    $("#result").html('');
//});


//$('#search').on('keyup', function (event) {



var timer;
$('#search').keyup(function (event) {

    $('#resultsContainer').fadeIn();
    $rut = $(this).val();
    var searchField = $rut;
    var expression = new RegExp(searchField, "i");
    event.preventDefault();
    clearTimeout(timer);
    timer = setTimeout(function () {
        $.ajax({
            type: "GET",
            url: '/api/coverage/getdoctypes/?cc=' + countryParam,
            dataType: 'JSON',
            success: function (docTypes) {
                $('#results').html('');
                $('#searching').hide();
                var match = 0;
                var noMatch = 0;

                const options = {
                    includeScore: true,
                    keys: [
                        "FriendlyName",
                    ]
                }

                const fuse = new Fuse(docTypes[0].Countries, options)

                const result = fuse.search(searchField)

                //console.log(result);

                if (result.length == 0) {
                    $('#results').append('<li class="list-group-item link-class">No matches found</li>');
                }
                else {
                    $.each(result, function (key, value) {
                        $('#results').append('<li class="list-group-item link-class"> ' + value.item.FriendlyName + '</li>');
                    });
                }

                //$.each(docTypes[0].Countries, function (key, value) {
                //    if (value.FriendlyName.search(expression) != -1 /*|| value.location.search(expression) != -1*/) {
                //        $('#results').append('<li class="list-group-item link-class"> ' + value.FriendlyName + '</li>');
                //        match ++
                //    }
                //    else {
                //        noMatch ++
                        
                //    }
                //});
                //if (match >= 1) {
                //    //console.log("Found results")
                //}
                //else if (match == 0 && noMatch >= 1) {
                //    //console.log("No matches")
                //    $('#results').append('<li class="list-group-item link-class">No matches found</li>');
                //}

            },
            error: function (docTypes) {
                console.log('An error occured')
            },
        });
    },800)
});

